/**
 * Web OAuth starts with a top-level navigation to the API (#393). The API sets the
 * optional age declaration and Auth.js's CSRF cookie on its own origin, then POSTs
 * same-origin to the provider sign-in route. A cross-site fetch + form POST from the
 * web app loses those SameSite=Lax cookies, which is why this is not done in the page.
 *
 * `birthday` is an ISO timestamp; it and `country` are only sent together.
 */
export const buildOAuthStartUrl = (input: {
  apiBase: string;
  provider: string;
  birthday?: string;
  country?: string;
}): string => {
  const url = new URL(`${input.apiBase}/api/auth/start/${encodeURIComponent(input.provider)}`);
  if (input.birthday && input.country) {
    url.searchParams.set('birthday', input.birthday);
    url.searchParams.set('country', input.country);
  }
  return url.toString();
};

/** Leaves the web app for the API. Separate so tests can stub the navigation. */
export const navigateToOAuthStart = (url: string): void => {
  window.location.assign(url);
};
